// src/stores/catalogStore.js
import { defineStore } from "pinia";
import { ref, computed } from "vue";
import CatalogService from "@/services/catalogService";

export const useCatalogStore = defineStore("catalog", () => {
  const loading = ref(false);
  const loaded = ref(false);
  const error = ref(null);

  const actions = ref([]);  // [{key,label}]
  const groups = ref([]);   // [{key,label,order}]
  const modules = ref([]);  // [{key,label,group,icon}]
  const aliases = ref({});  // { Clients: 'Client', ... }

  const actionKeys = computed(() => actions.value.map((a) => a.key));
  const moduleKeys = computed(() => modules.value.map((m) => m.key));

  function normalizeModuleKey(k) {
    const key = String(k || "").trim();
    if (!key) return "";
    return aliases.value?.[key] || key;
  }

  function normalizePermissionName(p) {
    // "Clients.Read" -> "Client.Read"
    const s = String(p || "");
    if (!s.includes(".")) return s;
    const [mod, act] = s.split(".");
    return `${normalizeModuleKey(mod)}.${act}`;
  }

  async function fetchPermissionsCatalog(force = false) {
    if (loaded.value && !force) return;

    loading.value = true;
    error.value = null;
    try {
      const res = await CatalogService.permissionsCatalog();
      const data = res?.data || {};

      actions.value = Array.isArray(data.actions) ? data.actions : [];
      groups.value = Array.isArray(data.groups) ? data.groups : [];
      modules.value = Array.isArray(data.modules) ? data.modules : [];
      aliases.value = data.aliases && typeof data.aliases === "object" ? data.aliases : {};

      loaded.value = true;
    } catch (e) {
      error.value = e?.response?.data?.message || e?.message || "Failed to load catalogs";
      loaded.value = false;
      throw e;
    } finally {
      loading.value = false;
    }
  }

  return {
    loading,
    loaded,
    error,
    actions,
    groups,
    modules,
    actionKeys,
    moduleKeys,
    normalizeModuleKey,
    normalizePermissionName,
    fetchPermissionsCatalog,
  };
});
